import { render, staticRenderFns } from "./VeterinariasPrueba.vue?vue&type=template&id=89e230bc&scoped=true&"
import script from "./VeterinariasPrueba.vue?vue&type=script&lang=js&"
export * from "./VeterinariasPrueba.vue?vue&type=script&lang=js&"
import style0 from "./VeterinariasPrueba.vue?vue&type=style&index=0&id=89e230bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e230bc",
  null
  
)

export default component.exports